import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancelled() {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-4">
      <div className="w-full max-w-md text-center">
        {/* Icon */}
        <div className="flex justify-center mb-6">
          <XCircle size={80} className="text-orange-500" strokeWidth={1.5} />
        </div>

        {/* Heading */}
        <h1 className="text-3xl font-bold text-gray-800 mb-2">
          Pagamento annullato
        </h1>

        {/* Subtitle */}
        <p className="text-gray-500 text-lg mb-8">
          Il pagamento non e andato a buon fine.
        </p>

        {/* Actions */}
        <div className="space-y-3">
          <button
            onClick={() => window.history.back()}
            className="w-full bg-blue-600 text-white py-4 rounded-xl font-bold text-lg min-h-touch flex items-center justify-center"
          >
            Riprova
          </button>

          <Link
            to="/"
            className="w-full border border-gray-200 text-gray-600 py-4 rounded-xl font-medium text-lg min-h-touch flex items-center justify-center"
          >
            Torna al menu
          </Link>
        </div>
      </div>
    </div>
  );
}
